import React from 'react';
import styles from '../../../event-timeline.module.css';

interface NoParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const NoParams: React.FC<NoParamsProps> = () => {
  return (
    <div className={styles.parameterContainer}>
      <span>No parameters needed</span>
    </div>
  );
};

export default NoParams;
